<template>
    <div>
        <router-view name="homeRouter"></router-view>
    </div>
</template>

<script>

    export default {
        name: 'home_main'
    }
</script>

<style>
</style>
